export default __webpack_public_path__ + "static/ECB-e0e1795bb7350cf06d9dcdf818ab90c5.png";